import { render, staticRenderFns } from "./LandingV2.vue?vue&type=template&id=1454e224&scoped=true"
import script from "./LandingV2.vue?vue&type=script&lang=js"
export * from "./LandingV2.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/landing-v2.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./LandingV2.vue?vue&type=style&index=1&id=1454e224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1454e224",
  null
  
)

export default component.exports